/* Third Party Info - ThirdPartyInfo.jsx */
.cardContainer {
  display: block;
  position: relative;
  background-color: #f7f7f7;
  border-radius: 20px;
  border-top: 1px solid;
  border-right: 1px solid;
  border-color: #e5e7e9;
  box-shadow: -15px 30px 15px -10px rgba(0, 0, 0, 0.75);
  padding-top: 30px;
  width: 295px;
  max-width: 100%;
  height: auto;
  max-height: 100%;
  text-align: center;
  color: #0d2137;
  margin-left: 3%;
  margin-bottom: 3%;
}

.cardContainerDisabled {
  display: block;
  position: relative;
  border-radius: 20px;
  border-top: 1px solid;
  border-right: 1px solid;
  border-color: #e5e7e9;
  box-shadow: -15px 30px 15px -10px rgba(0, 0, 0, 0.75);
  padding-top: 30px;
  width: 295px;
  max-width: 100%;
  height: auto;
  max-height: 100%;
  text-align: center;
  color: #0d2137;
  margin-left: 3%;
  margin-bottom: 3%;
  background-color: #bbb;
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  cursor: not-allowed;
}

.cardContainerSigner {
  display: block;
  position: relative;
  background-color: #f8f9f9;
  border-radius: 20px;
  border-top: 1px solid;
  border-right: 1px solid;
  border-color: #367c2b;
  box-shadow: -15px 30px 15px -10px #367c2b;
  padding-top: 30px;
  width: 295px;
  max-width: 100%;
  height: auto;
  max-height: 100%;
  text-align: center;
  color: #0d2137;
  margin-left: 3%;
  margin-bottom: 3%;
}

.cardContainerDuplicateSigner {
  display: block;
  position: relative;
  background-color: #f8f9f9;
  border-radius: 20px;
  border-top: 1px solid;
  border-right: 1px solid;
  border-color: #d24625;
  box-shadow: -15px 30px 15px -10px #d24625;
  padding-top: 30px;
  width: 295px;
  max-width: 100%;
  height: auto;
  max-height: 100%;
  text-align: center;
  color: #0d2137;
  margin-left: 3%;
  margin-bottom: 3%;
}

.talf_id {
  margin-top: -5px;
  font-size: 10px;
  color: #808080;
}

.clr {
  clear: both;
}
.cardHeader {
  display: block;
  margin-top: -15px;
}

.signerName {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 25%;
}

.signerName span {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  padding-right: 2%;
  text-align: left;
  min-width: 65%;
}

.signerName .avatar {
  margin-left: 8px;
  margin-right: 5px;
  font-size: 320%;
}

.signerEnabled {
  display: inline;
  margin-left: 10px;
  float: left;
  padding-left: 4px;
  border-radius: 5px;
}

.signerLabel {
  font-weight: bold;
  font-size: 13px;
}

.cardHeader .role {
  background-color: #367c2b;
  text-transform: capitalize;
  color: white;
  border-radius: 5px;
  font-size: 11px;
  font-weight: bold;
  padding: 5px 7px;
  margin-right: 10px;
  display: inline;
  float: right;
  max-width: 115px;
  word-wrap: break-word;
}

.signingActions {
  display: flex;
  margin-top: 9px;
  margin-right: 5px;
  margin-left: 5px;
}


.signOrder {
  display: inline;
  min-width: 55px;
  margin-right: 5px;
}

.signOrder,
.signMethod {
  display: inline;
}

.signingActions P,
.contactInfo p {
  color: #808080;
  font-weight: bold;
  font-size: 12px;
  margin-bottom: 0;
  text-align: left;
}
.contactInfo p {
  margin-left: 7px;
}

.contactInfo {
  background-color: #e9f2f9;
  justify-content: inline-block;
  text-align: left;
  padding: 5px 0 2px 10px;
  margin-bottom: 15px;
  margin-top: 15px;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
}

.contactInfo div {
  margin-right: 10px;
}

.contactInfoDisabled {
  justify-content: inline-block;
  text-align: left;
  padding: 5px 0 2px 10px;
  margin-top: 15px;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
  background-color: #bbb;
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  cursor: not-allowed;
}

.contactInfoDisabled div {
  margin-right: 10px;
}

.contactInfoDisabled p {
  color: #808080;
  font-weight: bold;
  font-size: 12px;
  margin-bottom: 0;
  text-align: left;
}
.contactInfoDisabled p {
  margin-left: 7px;
}

/* Add new signer */
.addNewSignerMain {
  margin: 2% 0 3% 3%;
}

.addNewSigner {
  display: block;
  border: 3px dashed #367c2b;
  width: 240px;
  height: 300px;
  max-height: 100%;
  border-radius: 20px;
  max-width: 100%;
  text-align: center;
  opacity: 0.6;
  color: #367c2b;
  cursor: pointer;
}
.addNewSigner:hover {
  opacity: 0.9;
}

.addNewSigner div {
  height: 300px;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

/* Third Party - index.jsx*/
.thirdPartiesTab {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: -3%;
}

.thirdPartyStepper {
  margin-top: 25px;
}

.stepperHeader {
  text-transform: uppercase;
  font-size: 13px;
  margin-bottom: 2px;
  font-weight: bold;
}

.contactInfo .contactNumberHelperText{
  color: #808080;
  font-weight: normal;
  font-size: 0.7rem;
  margin-bottom: -5%;
}

.contactInfoDisabled .contactNumberHelperText{
  color: #808080;
  font-weight: normal;
  font-size: 0.7rem;
  margin-bottom: -5%;
}


/* Add new signer pop up */

.addSignerDialog {
  margin: auto;
  width: 25rem;
}

.signerDialogTitle {
  display: flex;
  align-items: center;
  flex-direction: row;
  margin: 2% 2%;
  justify-content: space-between;
}

.signerDialogTitle > div > span {
  margin-left: 5px;
  font-weight: bold;
  font-size: 16px;
}

.odSignerDialogContent {
  margin-top: 2%;
  margin-left: 13%;
}
.odSignerInputLabel {
  color: #808080;
  font-size: 12px;
  margin-bottom: 3px;
  margin-left: 1px;
  text-align: left;
  font-weight: bold;
}

.odSignerTop {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 3%;
}

.odSignerTop .odSignerAvatar {
  font-size: 450%;
  margin-bottom: 1%;
}

.odSignerTop .signerRole {
  background-color: #367c2b;
  text-transform: capitalize;
  color: white;
  border-radius: 6px;
  font-size: 11px;
  font-weight: bold;
  padding: 5px 7px;
}

.signerId {
  font-size: 10px;
  font-weight: bold;
  color: #808080;
  margin-left: 4%;
}
